
export default {
    name: 'banner',
    data() {
        return {
            //标签
            labels: {
                id: '0'
            },
        }
    },
    methods: {
        //为高校教师平台写的特殊方法
        specialPlatform() {
            let address = this.$router.resolve({
                path: '/blank',
                query: {
                    zerotId: 0,
                    lableType: 'zeroLable',
                }
            });
            window.open(address.href, "_blank");
        },
        //获取类别标签
        allLabel(data, labelObj) {
            for (let i in data) {
                if (data[i].parent_id == labelObj.id) {
                    if (!labelObj.children) {
                        labelObj.children = [];
                    }
                    labelObj.children.push(data[i]);
                    this.allLabel(data, data[i]);
                }
            }
        },
        getLabel() {
            this.$getStoreId().then(data => {
                // if (data) {
                this.$post('labels/all', { shop_id: data }).then(res => {
                    // // console.log(res.data.result);
                    let data = res.data.result;
                    this.allLabel(data, this.labels);
                    
                    //判断是否有三级标签，有的话给一级添加个isWidth属性
                    for (let one of this.labels.children) {
                        if (one.children) {
                            // // console.log(111);
                            innter:
                            for (let two of one.children) {
                                if (two.children) {
                                    for (let three of two.children) {
                                        if (three) {
                                            one.isWidth = 'true';
                                            break innter;
                                        }
                                    }
                                }
                            }
                        }
                    }

                    let otherLabels = this.labels;
                    this.labels = { };
                    this.labels = otherLabels;
                })
            })
        },
        //获取首页数据
        getdata() {
            this.$getStoreId().then(id => {
                this.$post('sections/search', { shop_id: id, offset: 0, length: 999 }).then(res => {
                    this.sections = res.data.result.data;
                    //因为返回的对象里面的数组有产品数组，也有项目包数组，若
                    this.sections.map(item => {
                        //若产品数组为空则删除产品数组这个属性
                        if (item.section_products.length == 0) {
                            //删除项目包数组这个属性
                            item.section_products = item.package_section;
                        }
                        delete item.package_section;
                    })
                    // // console.log(this.sections);
                })
            })

        },
        //点击一级标签
        firstLabel(firstId) {
            //判断式项目式的一级标签还是课程云的一级标签，若式项目式则调用另一个方法,否则就继续执行
            if (this.$store.state.store.is_project != "0") {
                this.projectLabel(firstId)
                return false;
            }

            //firstId=>一级标签的id
            let address = this.$router.resolve({
                path: '/classsearch',
                query: {
                    firstId: firstId,
                    lableType: 'firstLable',
                }
            });
            window.open(address.href, '_blank')
        },
        //点击二级标签
        secondLable(firstId, secondId) {
            //firstId=>一级标签的id
            let address = this.$router.resolve({
                path: '/classsearch',
                query: {
                    firstId: firstId,
                    secondId: secondId,
                    lableType: 'secondLable'

                }
            });
            window.open(address.href, '_blank');

        },
        //点击三级标签
        thirdLabel(firstId, secondId, thirdId, ) {
            let address = this.$router.resolve({
                path: '/classsearch',
                query: {
                    firstId: firstId,
                    secondId: secondId,
                    thirdId: thirdId,
                    lableType: 'thirdLable',
                }
            });
            window.open(address.href, '_blank');

        },
        ttt(){
            // // console.log(this.labels);
        }


    },

    mounted: function () {
        this.getLabel();
    }
}